const {createStore} = require('redux');

let ACTIONS = {
    GOT_OFFERS: (state, {offers}) => (Object.assign({}, state, {offers})),
    USER_DATA: (state, {userData}) => (Object.assign({}, state, {userData})),
    USER_PHONE: (state, {userPhone}) => (Object.assign({}, state, {userPhone})),
    SCREEN: (state, {screen}) => (Object.assign({}, state, {screen})),
    UUID: (state, {uuid}) => (Object.assign({}, state, {uuid})),
    SHOW_RESEND: (state, {showResend}) => (Object.assign({}, state, {showResend})),
};

const INITIAL = {
    offers: null
};

module.exports = createStore((state, action) => (
    action && ACTIONS[action.type] ? ACTIONS[action.type](state, action) : state
), INITIAL, typeof devToolsExtension === 'function' ? devToolsExtension() : undefined);
